import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonList, IonTabButton, IonButton } from '@ionic/angular/standalone';
import { GlobalService } from 'src/app/services/global.service';
import { MoodleWebService } from 'src/app/services/moodle-web.service';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/moodle';

@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
  standalone: true,
  imports: [IonButton, IonList, IonContent, CommonModule, FormsModule]
})
export class UserPage implements OnInit {
  public userInfos: WritableSignal<User> = signal<User>({fullname: ""});

  constructor(public globalService: GlobalService, public authService: AuthService, public moodleWebService: MoodleWebService) {     
    this.moodleWebService.getUserInfos(authService.currentUser().auth.id).then((user: User[]) => {       
      this.userInfos.set(user[0]); 
    });   
  }

  ngOnInit() {}
}
